<template>
    <svg :width="width" :height="height" viewBox="0 0 22 14" fill="none">
        <path
            d="M15.1367 0.426163L17.5894 2.87885L12.3627 8.10553L8.07851 3.82136L0.14209 11.7685L1.65226 13.2787L8.07851 6.85241L12.3627 11.1366L19.1102 4.39973L21.5629 6.85241V0.426163H15.1367Z"
            :fill="color"
            class="icon"
        />
    </svg>
</template>

<script>
export default {
    name: 'Improvement',
    props: {
        color: {
            type: String,
            default: '#6E6E6E',
        },
        width: {
            type: Number,
            default: 32,
        },
        height: {
            type: Number,
            default: 18,
        },
    },
}
</script>

<style lang="sass" scoped>
.icon
    transition: 0.5s ease all
</style>
